export const OVERLAY_ROOT_ID = 'overlay-root';
export const REGULAR_ROOT_ID = 'root';
export const STICKY_ROOT = 'sticky-root';
export const SEARCH_BOTTOM_ROOT = 'search-bottom-root';
export const COOKIE_ROOT = 'cookie-root';
